import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  tone?: 'brand' | 'light';
  className?: string;
}
export function CtaButton({
  children,
  size = 'md',
  tone = 'brand',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-[15px]' : 'px-6 py-3 text-[13px]';
  const toning = tone === 'light' ? 'bg-white text-brand-700 hover:bg-brand-50 focus-visible:outline-white' : 'bg-brand-700 text-white hover:bg-brand-600 focus-visible:outline-brand-600';
  return <a href="https://rylte.com/products/ryltes-gps-wireless-dog-fence" className={`group inline-flex items-center justify-center gap-2 rounded-md font-bold uppercase tracking-[0.08em] shadow-sm transition-[background-color,transform] duration-150 ease-smooth focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 active:scale-[0.985] ${sizing} ${toning} ${className}`} data-id="element-35" data-mp="10a3plz45f4ug">
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-0.5" data-id="element-36" data-mp="35y7kyl1od925" />
    </a>;
}